import { z } from 'zod';
import {
  dateRangeSchema,
  paginationFiltersSchema,
  sortFiltersSchema,
} from 'utils/schemas';

export const recognitionGiversFiltersSchema = z
  .object({
    search: z.string().catch(''),
    date: dateRangeSchema,
    achievements: z.array(z.string()).catch([]),
  })
  .merge(paginationFiltersSchema)
  .merge(sortFiltersSchema);

export const recognitionGiverRecipientsFiltersSchema = z
  .object({
    date: dateRangeSchema,
    achievements: z.array(z.string()).catch([]),
  })
  .merge(paginationFiltersSchema);
